export const ImageTypes = {
    OUTFIT: 'OUTFIT',
    AMBIENTE: 'AMBIENTE',
    FULL_FIGURE: 'FULL_FIGURE'
};
